import { createQueryKeys } from 'query-keys';
import { ParcelId } from '../../../slices/parcels';

export const cropQueryKeys = createQueryKeys('crops', {
  parcelHistory: (parcelId?: ParcelId) => ({ parcelId }),
});
